export const distanceFormatter = (distance: number): string =>
  distance < 1 ? `${distance * 1000}m` : `${Math.ceil(distance * 10) / 10}km`
